// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__O3e4N","buttons":"Footer_buttons__1jSYW"};